import TurboFrameSearchController from "./shared/turbo_frame_search.js";

export default class extends TurboFrameSearchController {
  get focusAttributes() {
    return {
      pending: "data-easy-request-launcher-search-pending",
      caretStart: "data-easy-request-launcher-search-caret-start",
      caretEnd: "data-easy-request-launcher-search-caret-end",
    };
  }
}
